import { loading } from "../include/module";
import { anchorLink } from "../include/module";
import { resizeHeader } from "../include/module";
import { mainSlider } from "../include/module";
import { langToggle } from "../include/module";
import { menuToggle } from "../include/module";
import { movieSlider } from "../include/module";
import { recoSlider } from "../include/module";
import { scrlInit } from "../include/module";
import { accToggle } from "../include/module";
import { inputSync } from "../include/module";
import { srchToggle } from "../include/module";





(() => {

  loading();
  anchorLink();
  resizeHeader();
  mainSlider();
  langToggle();
  menuToggle();
  movieSlider();
  recoSlider();
  scrlInit();
  accToggle();
  inputSync();
  srchToggle();

})();



// WEBPACK FOOTER //
// ./src/assets/js/game/script.js